export function hasPermission(
  permissions: string[] | null | undefined,
  required: string | undefined,
): boolean {
  if (!required) return true;
  if (!permissions) return false;
  if (permissions.includes('*:*:*')) return true;
  if (permissions.includes(required)) return true;
  const [resource] = required.split(':');
  if ((resource === 'settings' || resource === 'system') && permissions.includes('system:admin:all')) {
    return true;
  }
  return false;
}
